import { type ReactElement, type ReactNode } from "react"
import { RootState } from "src/app/store";
import { useSelector } from "react-redux";
import { OrderType } from "../../types/OrderType";

export interface OrderReportProps {
        order?: OrderType,
        children?: ReactNode
}

export function OrderReport(props: OrderReportProps): ReactElement {

        return <>
                <div className="flex flex-col items-center gap-8 m-12">
                        <h1 className="text-3xl font-bold">Order Details:</h1>
                        <h2 className="flex flex-col justify-center gap-4 w-full">
                                <div className="flex justify-center">
                                        <p className="font-bold">Order ID : </p>
                                        <p className="">{props.order?.OrderId}</p>
                                </div>
                                <div className="flex justify-center flex-wrap">
                                        <p className="font-bold">Dealer : </p>
                                        <p className="">{props.order?.DealerName}</p>
                                </div>
                                <div className="flex justify-center flex-wrap">
                                        <p className="font-bold">EndUser : </p>
                                        <p className="">{props.order?.EndUserName}</p>
                                </div>
                                <div className="flex justify-center flex-wrap">
                                        <p className="font-bold">EndUserInstance : </p>
                                        <p className="">{props.order?.EndUserInstanceName}</p>
                                </div>
                                <div className="flex justify-center flex-wrap">
                                        <p className="font-bold">EndUserInstanceLocation : </p>
                                        <p className="">{props.order?.EndUserInstanceLocationName}</p>
                                </div>
                                <div className="flex justify-center flex-wrap">
                                        <p className="font-bold">Number Of Doors : </p>
                                        <p className="">{props.order?.NumberOfDoors}</p>
                                </div>
                                <div className="flex justify-center flex-wrap">
                                        <p className="font-bold">Ordered Date : </p>
                                        <p className="">{props.order?.OrderDate}</p>
                                </div>
                        </h2>
                </div>
        </>
}
